module.exports = __webpack_public_path__ + "static/img/thirty_two.accdbb06.svg";